<template>
  <div class="home">
    <div class="home-item" @mouseenter="stopAutoPlay" @mouseleave="autoPlay">
      <div
        style="
          position: relative;
          height: 100%;
          margin: 0 auto;
          justify-content: space-around;
          max-width: 1980px;
        "
        class="center"
      >
        <div>
          <div class="home-item-title">
            <div
              class="home-item-title-text"
              :style="{ color: carousels[activeCarousels].color }"
            >
              YLab Cloud
            </div>
            <div class="home-item-title-text">
              <span
                >为中小型研发机构提供完整的实验室管理解决方案，引领管理升级和支撑业务发展。提高实验的速度，质量，公平性。</span
              >
            </div>
          </div>
          <div
            class="home-item-btn center"
            :style="{ background: carousels[activeCarousels].color }"
            @click="$router.push('/')"
          >
            免费试用
          </div>
        </div>

        <div class="center" style="flex-direction: column">
          <div style="position: relative; width: 710px; height: 428px">
            <img
              v-for="(item, index) in carousels"
              :key="item.name"
              :src="item.img"
              alt=""
              style="
                width: 710px;
                height: 428px;
                position: absolute;
                top: 0;
                left: 0;
                transition: all 0.5s ease-in-out;
              "
              :style="{
                opacity: activeCarousels === index ? '1' : '0',
              }"
            />
          </div>
          <div style="gap: 13px; margin-top: 30px" class="center">
            <div
              v-for="(item, index) in carousels"
              :key="item.name"
              style="
                width: 96px;
                height: 86px;
                background: #ffffff;
                border-radius: 10px 10px 10px 10px;
                gap: 10px;
                flex-direction: column;
                position: relative;
                cursor: pointer;
                user-select: none;
              "
              class="center"
              @click="changeActiveCarousels(index)"
            >
              <img :src="item.icon" alt="" style="width: 28px; height: 28px" />
              <span
                style="font-size: 14px; color: #333333; line-height: 18px"
                >{{ item.name }}</span
              >

              <img
                src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/选中-180746360.png"
                alt=""
                style="position: absolute; top: 10px; left: 10px"
                v-if="activeCarousels === index"
              />
              <div
                v-else
                style="
                  width: 16px;
                  height: 16px;
                  background: #ffffff;
                  border: 1px solid #e5e5e5;
                  border-radius: 50%;
                  position: absolute;
                  top: 10px;
                  left: 10px;
                "
              ></div>
            </div>
          </div>
        </div>

        <img
          v-for="(item, index) in carousels"
          :key="item.name"
          :src="item.bg"
          class="home-bg"
          alt=""
          :style="{
            opacity: activeCarousels === index ? '1' : '0',
          }"
        />
      </div>
    </div>
    <div class="home-item">
      <div class="home-item-title w1200" style="position: relative">
        <div>精选模板 一步到位</div>
        <div>内置标准化管理方案，支持个性化修改。</div>

        <img
          src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/05/点缀-091308641.png"
          alt=""
          style="
            position: absolute;
            top: -40px;
            left: 0px;
            width: 1200px;
            height: 124px;
            z-index: -1;
          "
        />
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="item in templates" :key="item.id" class="swiper-slide">
            <div class="slide-text">{{ item.name }}</div>
            <div class="home-item-list-text">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="home-item-btn center hover-btn">
          <span @click="$router.push('/')">立刻体验模板</span
          ><i class="el-icon-arrow-right"></i>
          <div
            style="
              width: 180px;
              height: 44px;
              background: #2e98fe;
              border-radius: 6px 6px 6px 6px;
              opacity: 0.4;
              filter: blur(10px);
              position: absolute;
              top: 10px;
              left: 12px;
              z-index: -1;
            "
          ></div>
        </div>
      </div>
    </div>
    <div class="home-item">
      <div class="home-item-title">
        <div>强大功能 简单操作</div>
        <div>提供全方位的功能模块，满足企业各类业务场景需求</div>
      </div>

      <div class="home-item-content">
        <div class="home-item-content-left">
          <div class="home-item-list">
            <div
              class="home-item-list-item"
              v-for="item in modules"
              :key="item.name"
              :class="{ active: item.name === activeModule }"
              @click="activeModule = item.name"
            >
              <img :src="item.icon" alt="" />
              <div class="home-item-list-text">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="home-item-content-right">
          <div
            style="
              width: 100%;
              height: 100%;
              background: #fff;
              border-radius: 8px;
              padding: 10px 35px;
            "
          >
            <div
              style="
                width: 355px;
                font-size: 14px;
                color: #636e80;
                line-height: 22px;
                margin-bottom: 10px;
              "
            >
              灵活搭建，通过拖拽即可快速创建各类业务表单，支持丰富的字段类型和灵活的布局方式
            </div>

            <!-- <div > -->
            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/组 858@2x-171450874.png"
              alt=""
              style="width: 762px; height: 420px"
            />
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="home-item">
      <div class="home-item-title">
        <div>为什么选择CLOUD</div>
        <div>
          我们的ylab平台为企业提供快速数字化转型的能力，无需专业开发技能即可构建业务应用
        </div>
      </div>
      <div class="home-item-content w1200">
        <div v-for="item in reasons" :key="item.name" class="home-item-reasons">
          <img :src="item.icon" alt="" />
          <div class="home-item-reasons-name">{{ item.name }}</div>
          <div class="home-item-reasons-text">{{ item.text }}</div>
          <div class="home-item-reasons-btn" @click="$router.push('/')">
            免费试用
          </div>
        </div>
      </div>
    </div>
    <div class="home-item">
      <div
        style="
          font-weight: 500;
          font-size: 40px;
          color: #1d2129;
          line-height: 44px;
        "
      >
        现在开始，开启您的数字化之旅
      </div>
      <div class="center" style="margin-top: 44px">
        <div
          style="
            width: 168px;
            height: 48px;
            background: #2e98fe;
            border-radius: 6px 6px 6px 6px;
            font-weight: 500;
            font-size: 20px;
            color: #ffffff;
            line-height: 48px;
            cursor: pointer;
          "
          class="hover-btn"
          @click="$router.push('/')"
        >
          <span style="margin-right: 12px">立即试用</span
          ><i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/za@2x-180518035.png"
        alt=""
        class="home-item-left"
      />
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/yb@2x-180518028.png"
        alt=""
        class="home-item-right"
      />
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { templatePage } from "@/api/module";
export default {
  name: "SiteHome",
  data() {
    return {
      phone: "",
      templates: [],
      carousels: [
        {
          name: "进销存",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/进销存／仓库-153057517.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/青-175324248.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/进销存-175324180.png",
          color: "#2E98FE",
        },
        {
          name: "CRM/销售",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/CRM／销售-153057530.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/蓝 (1)-175404160.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/CRM／销售 (1)-175404055.png",
          color: "#0C54E6",
        },
        {
          name: "人事管理",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/人事／行政-153057535.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/绿-175447514.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/人事管理-175447349.png",
          color: "#00BBAD",
        },
        {
          name: "项目管理",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/项目／任务-153057525.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/紫-175530998.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/项目管理-175530853.png",
          color: "#6F40FD",
        },
        {
          name: "财务管理",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/财务／报销-153057490.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/蓝 (2)-175608743.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/财务管理-175608668.png",
          color: "#0C54E6",
        },
        {
          name: "OA行政",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/财务／报销 (1)-153057506.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/青 (1)-175641411.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/OA行政-175641290.png",
          color: "#2E98FE",
        },
        {
          name: "其他",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/其他 (1)-153057500.png",
          bg: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/蓝-152650401.png",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/04/其他 (2)-171330851.png",
          color: "#2E98FE",
        },
      ],
      activeCarousels: 6,

      modules: [
        {
          name: "可视化表单设计",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/可视化表单设计@2x-162128413.png",
        },
        {
          name: "智能流程引擎",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/智能流程引擎@2x-162128399.png",
        },
        {
          name: "动态数据仪表盘",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/动态数据仪表盘@2x-162128403.png",
        },
        {
          name: "多平台使用",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/多平台使用@2x-162128387.png",
        },
        {
          name: "数据开放对接",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/数据开放对接@2x-162128392.png",
        },
      ],
      activeModule: "可视化表单设计",
      reasons: [
        {
          name: "灵活搭建 业务人员也能用",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/组 725@2x-165817084.png",
          text: "拖拽字段，配置规则，无需编写一行代码，快速响应业务需求。",
        },
        {
          name: "全场景应用 随需而变",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/组 726@2x-165817092.png",
          text: "从OA审批到CRM、ERP，覆盖人事、财务、 销售等上百个业务场景。",
        },
        {
          name: "数据实时分析 洞察业务全局",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/组 730@2x-165817076.png",
          text: "自动汇总数据，生成多维度报表与可视化仪表盘，辅助科学决策。",
        },
        {
          name: "打通信息孤岛 提升团队效能",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/组 729@2x-165817069.png",
          text: "",
        },
      ],
      timer: null,
    };
  },
  async mounted() {
    const { data } = await templatePage({ pageNumber: 1, pageSize: 10 });
    this.templates = data.records;
    this.$nextTick(() => {
      this.initSwiper();
    });
    this.autoPlay();
  },
  methods: {
    autoPlay() {
      this.timer = setInterval(() => {
        this.activeCarousels += 1;
        if (this.activeCarousels >= this.carousels.length) {
          this.activeCarousels = 0;
        }
      }, 3000);
    },

    stopAutoPlay() {
      clearInterval(this.timer);
    },
    changeActiveCarousels(index) {
      this.activeCarousels = index;
    },
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        slidesPerView: "auto",
        spaceBetween: 32,
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
    this.stopAutoPlay();
  },
};
</script>

<style scoped lang="less">
.home {
  .home-item {
    width: 100%;
    &:nth-child(1) {
      height: 686px;
      position: relative;
      .home-bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover; /* 让图像覆盖整个容器 */
        object-position: right center; /* 将图像的左侧定位在容器的中心 */
        z-index: -1;
        transition: all 0.5s ease-in-out;
      }

      .home-item-title {
        .home-item-title-text {
          width: 506px;
          &:nth-child(1) {
            font-weight: 700;
            font-size: 50px;
            color: #1d2129;
            line-height: 50px;
          }
          &:nth-child(2) {
            margin-top: 30px;
            font-size: 24px;
            color: #333333;
            line-height: 40px;
          }
        }
      }

      .home-item-btn {
        margin-top: 40px;
        width: 180px;
        height: 46px;
        background: #2e98fe;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
      }
    }
    &:nth-child(2) {
      height: 712px;
      padding: 86px 0;
      .swiper-container {
        margin-top: 40px;
        height: 320px;
      }
      .home-item-title {
        text-align: center;
        div {
          &:nth-child(1) {
            font-weight: 500;
            font-size: 40px;
            color: #1d2129;
            line-height: 40px;
          }
          &:nth-child(2) {
            margin-top: 20px;
            font-size: 18px;
            color: #1d2129;
            line-height: 20px;
          }
        }
      }
      .swiper-slide {
        width: 274px;
        height: 320px;
        padding: 25px 17px;
        background: #3880f7;
        border-radius: 10px;
        color: #fff;
      }
      .home-item-btn {
        width: 204px;
        height: 48px;
        background: #2e98fe;
        border-radius: 6px;
        margin-top: 40px;
        font-size: 18px;
        line-height: 20px;
        color: #fff;
        gap: 8px;
        position: relative;
        cursor: pointer;
      }
    }

    &:nth-child(3) {
      margin-bottom: 86px;
      .home-item-title {
        text-align: center;
        div {
          &:nth-child(1) {
            font-weight: 500;
            font-size: 40px;
            color: #1d2129;
            line-height: 40px;
          }
          &:nth-child(2) {
            margin-top: 20px;
            font-size: 18px;
            color: #1d2129;
            line-height: 20px;
          }
        }
      }
      .home-item-content {
        display: flex;
        justify-content: center;
        gap: 20px;
        margin-top: 40px;
        .home-item-content-left {
          width: 316px;
          height: 538px;
          background: linear-gradient(90deg, #eaf4fd 0%, #f3f9fe 100%);
          border-radius: 10px;
          padding: 40px 0;
          .home-item-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .home-item-list-item {
            height: 79px;
            display: flex;
            align-items: center;
            gap: 20px;
            padding-left: 30px;
            cursor: pointer;
            &.active {
              background: center / contain no-repeat
                url("https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/选中@2x (1)-164205686.png");
              color: #fff;
            }
            img {
              width: 34px;
              height: 39px;
            }
            .home-item-list-text {
              font-size: 18px;
              color: #1d2129;
              line-height: 26px;
            }
          }
        }
        .home-item-content-right {
          width: 864px;
          height: 538px;
          background: linear-gradient(
            90deg,
            #eff7fd 0%,
            #eaf5fd 56%,
            #eef8ff 100%
          );
          border-radius: 10px;
          padding: 10px;
        }
      }
    }

    &:nth-child(4) {
      background: #eaf4fd;
      height: 684px;
      padding-top: 80px;
      .home-item-title {
        text-align: center;
        div {
          &:nth-child(1) {
            font-weight: 500;
            font-size: 40px;
            color: #1d2129;
            line-height: 40px;
          }
          &:nth-child(2) {
            margin-top: 20px;
            font-size: 18px;
            color: #1d2129;
            line-height: 20px;
          }
        }
      }
      .home-item-content {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 27px;
        margin-top: 40px;
        .home-item-reasons {
          width: 585px;
          height: 182px;
          position: relative;
          cursor: pointer;
          overflow: hidden;

          .home-item-reasons-name {
            position: absolute;
            left: 30px;
            top: 83px;
            font-weight: 500;
            font-size: 18px;
            color: #1d2129;
            line-height: 20px;
            z-index: 2;
            transition: all 0.2s ease-in-out;
          }
          .home-item-reasons-text {
            position: absolute;
            left: 30px;
            top: 113px;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            width: 244px;
            z-index: 2;
            // transition: all 0.1s ease-in-out;
          }
          .home-item-reasons-btn {
            width: 104px;
            height: 40px;
            background: #2e98fe;
            border-radius: 4px 4px 4px 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #ffffff;
            position: absolute;
            left: 30px;
            bottom: 20px;
            opacity: 0;
            transition: all 0.2s ease-in-out;
          }
          &:hover {
            .home-item-reasons-name {
              top: 72px;
            }
            .home-item-reasons-text {
              display: none;
            }
            .home-item-reasons-btn {
              opacity: 1;
              bottom: 30px;
            }
          }
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    &:nth-child(5) {
      height: 360px;
      text-align: center;
      padding-top: 112px;
      background: no-repeat
        url("https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/矩形 1134@2x-180305440.png");
      position: relative;
      .home-item-left {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
      }
      .home-item-right {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
      }
    }
  }
}

.hover-btn {
  i {
    transition: all 0.1s ease-in-out;
  }
  &:hover {
    i {
      transform: translateX(10px);
    }
  }
}
</style>